import List from './component';

export default List;
